import React from "react";

const ListView = ({ cityList, onSelect }) => {
  return (
    <div className="citiesListContainer">
      {cityList.map((item) => {
        return (
          <div
            onClick={(e) => {
              e.stopPropagation();
              onSelect(item);
            }}
            className="cityNameContainer"
          >
            <p className="cityName">{item.name}</p>
          </div>
        );
      })}
    </div>
  );
};

export default ListView;
